class CustomiserEnd extends HTMLElement {
  constructor() {
    super()

    this.ui = {
      header: document.querySelector('packbags-header'),
      title: this.querySelector('.customiser-end__title'),
      selectionWrapper: this.querySelector('.customiser-end__selection'),
      basket: this.querySelector('.customiser-end__basket'),
      basketClose: this.querySelector('.customiser-end__basket-close'),
      basketButton: this.querySelector('.customiser-end__basket .basket__button'),
      button: this.querySelector('.customiser-end__button button'),
      continueShopping: this.querySelector('a.back'),
      priceWrapper: this.querySelector('.customiser-end__price'),
    }

    this.basket = null

    this.addToCart = this.addToCart.bind(this)
    this.addBasketToCart = this.addBasketToCart.bind(this)
  }

  connectedCallback() {
    this.ui.button.addEventListener('click', this.addToCart)
  }

  disconnectedCallback() {
    this.ui.button.removeEventListener('click', this.addToCart)
    if (this.ui.basket) {
      this.ui.basketButton.removeEventListener('click', this.addBasketToCart)
    }
  }

  renderSelection(selection) {
    this.ui.selectionWrapper.innerHTML = ''
    selection.forEach(item => {
      this.renderEndItem(item)
    })
  }

  setFinalPrice(price) {
    // console.log('setFinalPrice', price)
    this.ui.priceWrapper.textContent = `€${price}`
  }

  async setBasket(basket) {
    if (!basket) {
      this.ui.basket.remove()
    } else {
      try {
        const response = await fetch(`/products/${basket}.json`)
        const { product } = await response.json()

        // console.log(product, 'product')

        this.basket = {
          price: product.variants[0].price,
          title: product.title,
          id: product.variants[0].id,
          image: {
            src: product.image.src,
            width: product.image.width,
            height: product.image.height,
            alt: product.image.alt,
          },
        }

        this.updateBasketUI()
        this.ui.basketButton.addEventListener('click', this.addBasketToCart)
      } catch (error) {
        console.log('something went wrong - no basket option to be displayed', error)
      }
    }
  }

  updateBasketUI() {
    const default_span = this.ui.basketButton.dataset.starter
    const price_span = this.ui.basket.querySelector('.price_text')

    price_span.textContent = `€${this.basket.price}`
    this.ui.basketButton.dataset.text = default_span + `€${this.basket.price}`

    const imageContainer = this.querySelector('.basket__visual')

    // create image
    const image = document.createElement('img')
    image.src = this.basket.image.src
    image.width = this.basket.image.width
    image.height = this.basket.image.height
    image.alt = this.basket.image.alt

    imageContainer.appendChild(image)

    this.ui.basketClose.addEventListener('click', e => {
      e.preventDefault()
      this.ui.basket.classList.remove('--active')
    })
  }

  addBasketToCart() {
    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    const formData = new FormData()

    formData.append('items[][id]', this.basket.id)
    formData.append('items[][quantity]', 1)

    config.body = formData

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          console.log('error', response)
        } else {
          console.log('success', response)
          this.ui.header.increaseCartQuantity()
          window.location.href = '/cart'
        }
      })
  }

  renderEndItem(item) {
    const itemElement = document.createElement('div')
    itemElement.classList.add('customiser-end__selection-item')

    const title = document.createElement('h3')
    title.textContent = item.title

    const imageWrapper = document.createElement('div')
    const image = document.createElement('img')
    image.alt = `Product image of the product; ${item.title}`
    image.src = item.image

    itemElement.appendChild(title)
    imageWrapper.appendChild(image)
    itemElement.appendChild(imageWrapper)

    this.ui.selectionWrapper.appendChild(itemElement)
  }

  async addToCart() {
    await this.parentElement.addAllToCart()

    this.ui.title.textContent = 'Added to cart!'
    gsap.to(this.ui.button, { autoAlpha: 0, duration: 0.2 })
    if (this.ui.basket) {
      this.ui.basket.classList.add('--active')
    }

    gsap.to(this.ui.continueShopping, { y: 0, autoAlpha: 1, duration: 0.2 })
  }

  animateIn() {
    return gsap
      .timeline({ paused: true })
      .fromTo(this, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 })
      .restart()
  }
}

if (!customElements.get('customiser-end')) {
  customElements.define('customiser-end', CustomiserEnd)
}
